<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version" class="form-group__label"></label>
  }
  <input type="text" class="form-control"
    [placeholder]="question?.question_prompt"
    [name]="uniqueControlName"
    [id]='uniqueId'
    [(ngModel)]="value"
    (ngModelChange)="saveValue()"
    [mask]="'0000/000000/00'"
    [showMaskTyped]="true"
    [dropSpecialCharacters]="false"
    [placeHolderCharacter]="'_'">
  </div>